import { Center, Spinner, Text } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import Pagination from 'presentation/components/shared/pagination/Pagination/Pagination';

interface Props
  extends Omit<PaginationListProps<any>, 'items'>,
    PropsWithChildren {
  itemsCount: number;
}

const PaginationContentWrap: FC<Props> = ({
  isFetching,
  setPage,
  currentPage,
  pageCount,
  itemsCount,
  children,
}) => {
  const { t } = useTranslation();

  if (itemsCount > 0) {
    return (
      <>
        {!isFetching ? (
          children
        ) : (
          <Center p="20px">
            <Spinner />
          </Center>
        )}

        {pageCount > 1 && (<Pagination
          onPageChanged={setPage}
          pageCount={pageCount}
          currentPage={currentPage}
        />)}
      </>
    );
  } else {
    return <Text textAlign="center">{t('listIsEmpty')}</Text>;
  }
};

export default PaginationContentWrap;
